class DynamicHeader {
  constructor() {
    this.header = document.getElementById('site-header');
    this.scrollTreshold = 100;
    this.events();
  }

  events() {
    window.addEventListener('scroll', () => {
      if (window.scrollY > this.scrollTreshold) {
        this.header.classList.add('scrolled');

      } else {
        this.header.classList.remove('scrolled');
      }
    });
  }
}
export default DynamicHeader;